import { StrUtil } from '@/utils/StrUtil'

export const checkIsMatrixFile = (file) => {
  return new Promise(function (resolve,reject) {
    let reader = new FileReader()
    if(!file) {
      reject("文件为空")
    }
    reader.readAsText(file, 'UTF-8')// 如果出现乱码，可以更换编码
    reader.onload = function (e) {
      let text = reader.result
      let lines = text.trim().split('\n')
      let head = lines[0].trim().split('\t')
      let headLen = head.length
      let headSet = new Set
      let rowNameSet = new Set
      head.slice(1).forEach((item, index) => {
        let elem = item.trim()
        if(StrUtil.isBlank(elem)) {
          reject('第' + (index + 2) + '列列名数据为空')
        }
        if(!headSet.has(elem)) {
          headSet.add(elem)
        } else {
          reject('第' + (index + 2) + '列列名数据重复')
        }
      })
      lines.slice(1).forEach((line, index) => {
        let rowData = line.trim().split('\t')
        if(rowData.length != headLen) {
          reject('第' + (index + 2) + '行数据与表头数量不一致')
        }
        if(rowNameSet.has(rowData[0].trim())) {
          reject('第' + (index + 2) + '行行名重复')
        } else {
          rowNameSet.add(rowData[0].trim())
        }
        rowData.slice(1).forEach((item, j) => {
          if(StrUtil.isBlank(item)|| isNaN(Number(item))) {
            reject('第' + (index + 2) + '行, 第' + (j + 2) + '列数据不是数字')
          }
        })
      })
      resolve()
    }
  })
}

export const checkSampleFile = (file) => {
  return new Promise(function (resolve,reject) {
    let reader = new FileReader()
    if(!file) {
      reject("文件为空")
    }
    reader.readAsText(file, 'UTF-8')// 如果出现乱码，可以更换编码
    reader.onload = function (e) {
      let text = reader.result
      let lines = text.trim().split('\n')
      let head = lines[0].trim().split('\t')
      let headLen = head.length
      let headSet = new Set
      let rowNameSet = new Set
      head.slice(1, -1).forEach((item, index) => {
        let elem = item.trim()
        if(!elem) {
          reject('第' + (index + 2) + '列列名数据为空')
        }
        if(!headSet.has(elem)) {
          headSet.add(elem)
        } else {
          reject('第' + (index + 2) + '列列名数据重复')
        }
      })
      lines.slice(1).forEach((line, index) => {
        let rowData = line.trim().split('\t')
        if(rowData.length != headLen) {
          reject('第' + (index + 2) + '行数据与表头数量不一致')
        }
        if(rowNameSet.has(rowData[0].trim())) {
          reject('第' + (index + 2) + '行行名重复')
        } else {
          rowNameSet.add(rowData[0].trim())
        }
        rowData.slice(1, -1).forEach((item, j) => {
          if(StrUtil.isBlank(item)|| isNaN(Number(item))) {
            reject('第' + (index + 2) + '行, 第' + (j + 2) + '列数据不是数字')
          }
        })
      })
      resolve()
    }
  })
}


